import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
  Container, TimerEle, Divider,
} from '../styles/countdown.style';

const propTypes = {
  backgroundImage: PropTypes.object,
  textColor: PropTypes.string,
};

const defaultProps = {
  backgroundImage: {
    file: {},
  },
  textColor: '',
};

/**
 * Component that counts down to a date specified in the config
 */
class Countdown extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.update = this.update.bind(this);
    this.state = {
      days: '',
      hours: '',
      min: '',
      sec: '',
      timerID: null,
    };
  }

  /**
   * Initializes countdown when component is loaded on the page
   */
  componentDidMount() {
    const { countdownTo } = this.props;
    const start = moment();
    const duration = moment.duration(moment(countdownTo).diff(start));
    this.setState({
      hours: duration.hours(),
      min: duration.minutes(),
      days: Math.floor(duration.asDays()),
      sec: duration.seconds(),
      timerID: setInterval(() => {
        this.update();
      }, 1000),
    });
  }

  /**
   * Clears timer when the component unmounts
   */
  componentWillUnmount() {
    const { timerID } = this.state;
    clearInterval(timerID);
  }

  /**
   *  Update time value in state
   */
  update() {
    const { countdownTo } = this.props;
    const { timerID } = this.state;
    const start = moment();
    const duration = moment.duration(moment(countdownTo).diff(start));
    const d = Math.floor(duration.asDays());
    const h = duration.hours();
    const m = duration.minutes();
    const s = duration.seconds();
    this.setState({
      hours: h,
      min: m,
      days: d,
      sec: s,
    });
    if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
      clearInterval(timerID);
    }
  }

  /**
   * Renders Component
   * @returns {*} component JSX
   */
  render() {
    const {
      backgroundImage, textColor,
    } = this.props;
    const {
      days, hours, min, sec,
    } = this.state;
    return (
      <Container background={backgroundImage && backgroundImage.file && backgroundImage.file.url}>
        <TimerEle color={textColor}>
          <div className="time">{days}</div>
          <div className="label">
            { 'Day' }
            {days > 1 ? 's' : ''}
          </div>
        </TimerEle>
        <Divider />
        <TimerEle color={textColor}>
          <div className="time">
            {hours < 10 ? '0' : ''}
            {hours}
          </div>
          <div className="label">
            { 'Hour' }
            {hours > 1 ? 's' : ''}
          </div>
        </TimerEle>
        <Divider />
        <TimerEle color={textColor}>
          <div className="time">
            {min < 10 ? '0' : ''}
            {min}
          </div>
          <div className="label">
            { 'Minute' }
            {min > 1 ? 's' : ''}
          </div>
        </TimerEle>
        <Divider />
        <TimerEle color={textColor}>
          <div className="time">
            {sec < 10 ? '0' : ''}
            {sec}
          </div>
          <div className="label">
            { 'Second' }
            {sec > 1 ? 's' : ''}
          </div>
        </TimerEle>
      </Container>
    );
  }
}

Countdown.propTypes = propTypes;
Countdown.defaultProps = defaultProps;

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/countdown/components/countdown.js